module.exports = __webpack_public_path__ + "img/Sur.801ae4b0.jpg";